// @flow
import * as React from 'react';
import classNames from 'classnames';

export type LinkType = {
  children: string,
  text?: string,
  link: string,
  internal?: boolean,
  external?: boolean,
  download?: boolean,
  inverted?: boolean,
  type?: 'button' | 'submit',
  attr?: Object,
  className?: string,
};

const Link = (props: LinkType): React$Element<"a"> => {
  const {
    link, children, internal, inverted, download, external, type, className, attr = {},
  } = props;

  const linkClasses = classNames({
    link: true,
    'link--internal': internal,
    'link--external': external,
    'link--download': download,
    'link--inverted': inverted,
    className,
  });

  const attributes = {
    href: link,
    type,
    rel: external && 'noopener noreferrer',
    target: (external || download) && '_blank',
    download,
    ...attr,
  };

  return (
    <a {...attributes} className={linkClasses} >
      {children}
    </a>
  );
};

export default Link;
